import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { GridRow, GridItem, Spacer, useSnackbar, Link } from '@emburse/embark-core';
import { DataGridHeader } from '../../components';
import SingleColumnLayout from '../../components/Layouts/SingleColumnLayout';
import ReimbursementHistoryTable from './ReimbursementHistoryTable';
import { $t, useTranslation } from '../../hooks/useTranslation';
import { transformReimbursementHistoryData } from './utils';
import { getReimbursementHistory } from '../../api/reimbursement';
function ReimbursementHistory() {
    useTranslation();
    const didMount = useRef(false);
    const [reimbursementLoading, setReimbursementHistoryLoading] = useState(true);
    const [reimbursementHistory, setReimbursementHistoryData] = useState([]);
    const [reimbursementLink, setReimbursementLink] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    const updateData = useCallback(() => {
        getReimbursementHistory()
            .then((response) => response.json())
            .then((data) => {
            const { BackendUrl, Reimbursements } = data;
            setReimbursementHistoryData(Reimbursements.map(transformReimbursementHistoryData));
            setReimbursementHistoryLoading(false);
            setReimbursementLink(BackendUrl);
        });
    }, []);
    useEffect(() => {
        if (!didMount.current) {
            updateData();
            didMount.current = true;
        }
    }, [updateData, enqueueSnackbar]);
    return (_jsxs(SingleColumnLayout, { children: [_jsx(GridRow, { children: _jsx(GridItem, { children: _jsx(DataGridHeader, { title: $t('Reimbursement History') }) }) }), _jsx(Spacer, { size: 16 }), _jsx(GridRow, { children: _jsxs(GridItem, { children: [$t('The following table contains all reimbursements from the past 90 days. To view all historical data, please run the '), _jsx(Link, { href: reimbursementLink, children: $t('ACH Reimbursement History') }), $t(' report.')] }) }), _jsx(Spacer, { size: 16 }), _jsx(ReimbursementHistoryTable, { loading: reimbursementLoading, data: reimbursementHistory })] }));
}
export default ReimbursementHistory;
